import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Title, Text, Button, Group } from "@mantine/core";
import { IconArrowLeft, IconLock, IconShieldLock } from "@tabler/icons-react";
import "./styles.css";

const Unauthorized = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Unauthorized | Virel Admin";
  }, []);

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-background">
        <div className="unauth-orb unauth-orb-1"></div>
        <div className="unauth-orb unauth-orb-2"></div>
        <div className="unauth-orb unauth-orb-3"></div>
        <div className="grid-overlay"></div>
      </div>

      <Container size="md" className="content-wrapper">
        <div className="code-container">
          <div className="error-code-glow"></div>
          <h1 className="error-code">403</h1>
        </div>

        <Group justify="center" gap="xs" mb="md">
          <IconShieldLock size={24} color="#f97316" />
          <Text
            size="sm"
            tt="uppercase"
            fw={700}
            c="dimmed"
            style={{ letterSpacing: 2 }}
          >
            Access Denied
          </Text>
        </Group>

        <Title order={2} c="white" size="h1" mb="lg">
          Restricted <span style={{ color: "#ef4444" }}>Territory</span>
        </Title>

        <Text c="dimmed" size="lg" maw={500} mx="auto" mb={40}>
          You don't have the required permissions to view this content. Please
          contact your administrator if you believe this is an error.
        </Text>

        <div className="divider-line"></div>

        <Group justify="center" gap="md">
          <Button
            size="lg"
            variant="default"
            className="back-button"
            leftSection={<IconArrowLeft size={20} />}
            onClick={() => navigate(-1)}
            radius="md"
          >
            Go Back
          </Button>

          <Button
            size="lg"
            variant="filled"
            color="orange"
            leftSection={<IconLock size={20} />}
            onClick={() => navigate("/login")}
            radius="md"
            style={{
              boxShadow: "0 4px 20px rgba(249, 115, 22, 0.4)",
            }}
          >
            Login
          </Button>
        </Group>
      </Container>
    </div>
  );
};

export default Unauthorized;
